<div class="ngx-toastr" [ngClass]="type" id="responseMessages">
  <button *ngIf="options.closeButton" type="button" (click)="remove.emit(message)" class="toast-close-button" aria-label="Close">
    <span class="me-1 fs-4" *ngIf="count > 1">({{count}})</span>
    <span aria-hidden="true">&times;</span>
  </button>
  <div *ngIf="title$ | async as title" [class]="options.titleClass" [attr.aria-label]="title">
    {{ title }}
  </div>
  <ul class="list-unstyled text-wrap text-break mb-0">
    <ng-container *ngLet="isCollapsed() as isCollapsed">
      <li class="d-flex" *ngFor="let message of message.Messages | initial : (isCollapsed ? (message.Messages.length - config.apiResponseLineCollapseLimit) : 0); let isLast = last">
        <ng-container *ngIf="isCollapsed; else unCollapsed">
          <div class="text-pre my-auto" *ngIf="options.enableHtml" [innerHTML]="message | shorten: 150: '...'">
          </div>
          <div class="text-break text-wrap my-auto" *ngIf="!options.enableHtml">
            {{message | shorten: 150: '...'}}
          </div>
        </ng-container>
        <ng-template #unCollapsed>
          <div class="text-pre my-auto" *ngIf="options.enableHtml" [innerHTML]="message">
          </div>
          <div class="text-break text-wrap my-auto" *ngIf="!options.enableHtml">
            {{message}}
          </div>
        </ng-template>
        <div class="my-auto ms-3" *ngIf="isLast && hasMore">
          <button class="btn btn-link text-nowrap" aria-label="More" (click)="showMore = !showMore">
            <em *ngIf="!showMore">More...</em>
            <em *ngIf="showMore">Less...</em>
          </button>
        </div>
      </li>
      <li class="d-flex" *ngIf="showMore && message.Model && message.Model !== 'null'">
        <div class="text-pre" *ngIf="options.enableHtml" [innerHTML]="message.Model">
        </div>
        <div class="text-break text-wrap" *ngIf="!options.enableHtml">
          {{message.Model}}
        </div>
      </li>
    </ng-container>
  </ul>
</div>
